module.exports = __webpack_public_path__ + "static/media/ebarchitects_kabeza20217.140eadc9.jpg";